import { ModalType } from '../../../molecules/simple-modal/models/simple-modal.interfaces';
import {
  DropdownExpansionConfig,
  DropdownExpansionContent,
  DropdownExpansionStyles
} from '../models/dropdown-expansion.interfaces';

export const dropDownExpansionContentMock: DropdownExpansionContent = {
  button: {
    label: 'Filter/Sort',
    screenReaderLabel:
      'Changes to current Flight Search filter selection will automatically refresh the flight search result',
    icon: `<svg height="18" fill="#4470c3" viewBox="0 0 20 18" width="20" xmlns="http://www.w3.org/2000/svg">
<path d="M8.6625 1.28571V0.964286C8.6625 0.45 8.22937 0 7.73437 0H4.64062C4.14562 0 3.7125 0.45 3.7125
0.964286V1.28571H0V3.85714H3.7125V4.17857C3.7125 4.69286 4.14562 5.14286 4.64062 5.14286H7.73437C8.22937 5.14286 8.6625 4.69286
8.6625 4.17857V3.85714H19.8V1.28571H8.6625ZM4.95 3.85714V1.28571H7.425V3.85714H4.95ZM16.0875 7.39286C16.0875 6.87857 15.6544 6.42857 15.1594
6.42857H12.0656C11.5706 6.42857 11.1375 6.87857 11.1375 7.39286V7.71429H0V10.2857H11.1375V10.6071C11.1375 11.1214 11.5706 11.5714 12.0656
11.5714H15.1594C15.6544 11.5714 16.0875 11.1214 16.0875 10.6071V10.2857H19.8V7.71429H16.0875V7.39286ZM12.375 10.2857V7.71429H14.85V10.2857H12.375ZM8.6625 13.8214C8.6625 13.3071
8.22937 12.8571 7.73437 12.8571H4.64062C4.14562 12.8571 3.7125 13.3071 3.7125 13.8214V14.1429H0V16.7143H3.7125V17.0357C3.7125 17.55 4.14562 18 4.64062 18H7.73437C8.22937 18 8.6625 17.55 8.6625
17.0357V16.7143H19.8V14.1429H8.6625V13.8214ZM4.95 16.7143V14.1429H7.425V16.7143H4.95Z">
</path></svg>`
  },
  headerLink: 'Reset All'
};

export const dropDownExpansionConfigMock: DropdownExpansionConfig = {
  showHeader: true
};

export const dropDownExpansionStylesMock: DropdownExpansionStyles = {
  content: { width: '100%' }
};

export const dropdownExpansionMocks = {
  config: dropDownExpansionConfigMock,
  content: dropDownExpansionContentMock,
  styles: dropDownExpansionStylesMock,
  closeFromOutside: false,
  loadBackground: true,
  showFooter: true,
  showCloseIcon: true,
  type: ModalType.Default,
  open: false
};
